import styled from 'styled-components';
import { colorPalette, device, getSpacing, typography } from 'stylesheet';

// Device height reserved for future responsive design
// const deviceHeight = window.innerHeight;
export const HomePageContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  @media (min-width: 1000px) {
    overflow-y: auto;
  }
  @media (max-width: 540px) {
    height: auto;
    margin-top: 15%;
  }
  @media (min-width: 540px) and (max-width: 900px) and (max-height: 500px) {
    height: auto;
    margin-top: 3%;
  }
`;

export const HomeImage = styled.img`
  width: 215px;
  height: 161px;
`;

export const Title = styled.h1`
  margin-top: ${getSpacing(4)};
  ${typography.title_small};
  margin-bottom: ${getSpacing(10)};
  > #highlightedName {
    text-transform: capitalize;
    color: ${colorPalette.secondary_600};
  }

  @media ${device.tabletMax} {
    margin-bottom: 4%;
  }
`;

export const MenuSectionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${getSpacing(5)};
  @media ${device.mobileMax} {
    flex-direction: column;
    gap: ${getSpacing(0)};
  }
  @media ${device.laptopLM} and (min-height: 700px) {
    flex-wrap: wrap;
    justify-content: center;
    gap: ${getSpacing(2)};
  }
  @media (max-width: 940px) and (max-height: 440px) {
    flex-wrap: wrap;
    justify-content: center;
    gap: ${getSpacing(2)};
  }
`;
